import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import { DiscountErrorFragment } from "@saleor/fragments/types/DiscountErrorFragment";
import { FormChange } from "@saleor/hooks/useForm";
import { SaleType } from "@saleor/types/globalTypes";
import { getFormErrors } from "@saleor/utils/errors";
import getDiscountErrorMessage from "@saleor/utils/errors/discounts";
import React from "react";
import { useIntl } from "react-intl";

import { SaleDetailsPageFormData } from "../SaleDetailsPage";

export interface SaleValueProps {
  currencySymbol: string;
  data: SaleDetailsPageFormData;
  disabled: boolean;
  errors: DiscountErrorFragment[];
  clientErrors: {
    value?: string;
  };
  onChange: FormChange;
}

const SaleValue: React.FC<SaleValueProps> = ({
  currencySymbol,
  data,
  disabled,
  errors,
  clientErrors,
  onChange
}) => {
  const intl = useIntl();

  const formErrors = getFormErrors(["value"], errors);

  const handleNumberChange = e => {
    if (/^[.0-9\b]+$/.test(e.target.value)) {
      onChange(e);
    }
  };

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Value",
          description: "sale value, header"
        })}
      />
      <CardContent>
        <TextField
          id="discountValueTxt"
          disabled={disabled}
          fullWidth
          label={intl.formatMessage({
            defaultMessage: "Discount Value",
            description: "sale discount"
          })}
          error={!!formErrors.value || !!clientErrors?.value}
          name="value"
          InputProps={{
            endAdornment: data.type === SaleType.FIXED ? currencySymbol : "%"
          }}
          helperText={
            getDiscountErrorMessage(formErrors.value, intl) ||
            clientErrors?.value
          }
          value={data.value}
          onChange={handleNumberChange}
          inputProps={{
            min: 0
          }}
        />
      </CardContent>
    </Card>
  );
};

SaleValue.displayName = "SaleValue";
export default SaleValue;
